import { GetterTree } from 'vuex'
import { KnowledgeBase, KnowledgeBlock } from '@/models/knowledge'
import { RootState } from '../../state'
import { KnowledgeState } from './state'

export const getters: GetterTree<KnowledgeState, RootState> = {
  getKnowledgeBases(state): KnowledgeBase[] {
    return state.bases
  },

  getKnowledgeBaseById: state => (
    baseId: string,
  ): KnowledgeBase | undefined => {
    return state.bases.find(b => b.id === baseId)
  },

  getSelectedKnowledgeBaseId(state): string | undefined {
    return state.selectedBaseId
  },

  getKnowledgeBlocks(state): Record<string, KnowledgeBlock[]> {
    return state.blocks
  },

  getKnowledgeBlocksBySectionId: state => (
    sectionId: string,
  ): KnowledgeBlock[] | undefined => {
    return state.blocks[sectionId]
  },

  getOpenSectionIds(state): string[] {
    return state.openSectionIds
  },

  getOpenBlockIds(state): string[] {
    return state.openBlockIds
  },
}
